export default __webpack_public_path__ + "static/media/logo-footer.cc248846.svg";